/* eslint-disable */
export const MAIL_REGEX = /^(?=.{6,80}$)([A-Za-z0-9_\-]+[\.]?)*[A-Za-z0-9_\-]+@([A-Za-z0-9_\-]+)\.([A-Za-z0-9_\-]+[\.]?)*([A-Za-z0-9_\-]*[A-Za-z][A-Za-z])$/;
export const PHONE_REGEX = /^\d{0,50}$/;
export const PASSWORD_REGEX = /^[a-zA-Z0-9~!@#$%+|()^*_\-=[\]{};:,./?]{8,50}$/;
export const PROFILE_REGEX_FIRST_NAME = /^[^<>&\[\]]{1,40}$/;
export const PROFILE_REGEX_LAST_NAME = /^[^<>&\[\]]{1,40}$/;
export const NUM_REGEX = /^\d+$/;